import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { ReportIssue } from "../components/Sidebar/General/ReportIssue";
import { Volunteering } from "../components/Sidebar/General/Volunteering";

import { useHttp } from "../hooks/use-http";

import { Helmet } from "react-helmet";

import {
  StyledTitle,
  StyledListContainer,
  StyledListSection,
  ListItemText,
  StyledIntro,
  StyledSectionHeaderComponent,
} from "../utils/common-styles";


export const NotFoundPage = (props) => {

  const { sendRequest } = useHttp();

  useEffect(() => {
    sendRequest(
      {
        url: "/errors/404",
        method: "PUT",
        body: {
          url: window.location.href,
        },
      },
      () => {}
    );
  }, [sendRequest]);

  return (
    <>
      <Helmet>
        <title>Page Not Found - The Friends of Queen's Wood</title>
        <meta name="description" content="The Friends of Queen's Wood page not found" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Page Not Found - The Friends of Queen's Wood" />
        <meta property="og:description" content="The Friends of Queen's Wood page not found" />
        <meta property="og:url" content={`${window.location.origin}`} />
        <meta name="twitter:title" content="Page Not Found - The Friends of Queen\'s Wood" />
        <meta name="twitter:description" content="The Friends of Queen\'s Wood page not found" />
      </Helmet>
      <StyledSectionHeaderComponent title="Page Not Found" />
      <StyledListSection>
        <StyledListContainer>
          <Row>
            <Col xs={12} md={9}>
              <p style={{ marginTop: "25px" }}>&nbsp;</p>

              <ListItemText>
                <StyledTitle>Page Not Found</StyledTitle>
              </ListItemText>

              <StyledIntro>
                The page you are looking for could not be found. Please check the URL and try again.
              </StyledIntro>
              <StyledIntro>
                Alternatively, you can return to the <a href="/">home page</a>.
              </StyledIntro>
            </Col>
            <Col xs={12} md={3}>
              <p style={{ marginTop: "25px" }}>&nbsp;</p>
              <ReportIssue />
              <Volunteering />
            </Col>
          </Row>
        </StyledListContainer>
      </StyledListSection>
    </>
  );
};
